import { useCallback } from 'react'
import { useCreateMediaObjects } from 'hooks/queries/mediaObjects/useCreateMediaObjects'
import { useCreateSource } from 'hooks/queries/workspaces/useCreateSource'
import { useCreateBrandKitSource } from 'hooks/queries/useCreateBrandKitSource'

export const useFileUpload = (brandKitId: number) => {
  const { mutateAsync: createMediaObjects, isLoading: isLoadingMediaObjects } = useCreateMediaObjects()
  const { mutateAsync: createSource, isLoading: isLoadingSource } = useCreateSource()
  const { mutateAsync: createBrandKitSource, isLoading: isLoadingBrandKitSource } = useCreateBrandKitSource()

  const handleUpload = useCallback(
    async (files: File[]) => {
      if (!files.length || !brandKitId) return

      const mediaObjects = await createMediaObjects(files.map((file) => ({ file, filename: file.name })))
      const brandKitSources = files.map(async (file, index) => {
        const mediaObject = mediaObjects[index]
        const source = await createSource({ media_object_id: mediaObject.id, type: 'SourceMaterialsMediaObject' })
        return createBrandKitSource({
          brandKitId,
          source: { type: 'SourceMaterialsMediaObject', id: source.source.id },
          name: file.name,
        })
      })

      return Promise.all(brandKitSources)
    },
    [brandKitId, createBrandKitSource, createSource, createMediaObjects],
  )

  return {
    handleUpload,
    isLoading: isLoadingMediaObjects || isLoadingSource || isLoadingBrandKitSource,
  }
}
